import React from "react";

export default class ChildRenderer extends React.Component {
  render() {
    return this.props.children;
  }
}
